export default "__VITE_ASSET___xV$1gb0__"